import { render, staticRenderFns } from "./cdn-social-bar.vue?vue&type=template&id=1b556647&scoped=true&"
import script from "./cdn-social-bar.vue?vue&type=script&lang=js&"
export * from "./cdn-social-bar.vue?vue&type=script&lang=js&"
import style0 from "./cdn-social-bar.vue?vue&type=style&index=0&id=1b556647&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b556647",
  null
  
)

export default component.exports